import { Singleton } from "util";
import BaseService from "./base.service";

@Singleton
class AccountingZipService extends BaseService {
  async fetch(company_uuid, month, year) {
    const formattedMonth = month.length === 1 ? `0${month}` : month;
    const url = `/v1/accounting_zip?month=${formattedMonth}&year=${year}&company_uuid=${company_uuid}`;
    return await this.get(url);
  }
}

export default AccountingZipService;



// WEBPACK FOOTER //
// ./src/core/service/accounting-zip.service.js